import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { Command } from 'cmdk';

import { cn } from 'styles';

type CommandMenuSeparatorProps = ComponentPropsWithoutRef<typeof Command.Separator>;

export const CommandMenuSeparator = forwardRef<
  ElementRef<typeof Command.Separator>,
  CommandMenuSeparatorProps
>(({ className, ...props }, ref) => (
  <Command.Separator ref={ref} className={cn('-mx-1 h-px bg-border', className)} {...props} />
));

CommandMenuSeparator.displayName = Command.Separator.displayName;
